<template>
  <div
    ref="wrapper"
    style="
      position: fixed;
      z-index: 9999;
      visibility: hidden;
      background: white;
    "
    class="tcv-context-menu"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var instance = this;
    document.addEventListener("click", function () {
      instance.close();
    });
    if (this.TargetSelector) {
      [...document.querySelectorAll(this.TargetSelector)].forEach((elmt) => {
        elmt.oncontextmenu = this.open;
      });
    }
  },
  methods: {
    open(event) {
      this.$nextTick(function () {
        // Get the menu element
        let menu = this.$refs.wrapper;

        // Get the event coordinates, which are already adjusted for scroll
        let x = event.pageX;
        let y = event.pageY;

        // Calculate the new position to ensure the menu stays within the viewport
        let top = y - window.scrollY;
        let left = x;

        // Check the bottom boundary
        if (y + menu.offsetHeight > window.innerHeight + window.scrollY) {
          top = y - menu.offsetHeight - document.scrollingElement.scrollTop;
        }

        // Check the right boundary
        if (x + menu.offsetWidth > window.innerWidth + window.scrollX) {
          left = x - menu.offsetWidth;
        }

        // Apply the new position
        menu.style.top = top + "px";
        menu.style.left = left + "px";

        // Display the menu
        menu.style.visibility = "visible";
      });
    },
    close() {
      if (this.$refs && this.$refs.wrapper) {
        let menu = this.$refs.wrapper;
        menu.style.visibility = "hidden";
      }
    },
  },
  props: ["TargetSelector"],
};
</script>
<style>
.tcv-context-menu {
  width: auto !important;
  background: white !important;
  border: 1px solid #afafaf !important;
}
</style>
